const initialState = {
  id: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'ID':
      const { id } = action;
      return {
        ...state,
        id,
      };
    default:
      return state;
  }
};

export const setId = (
  id,
) => ({
  type: 'ID',
  id,
});
